export function populateBlackCard(blackCard: string, whiteCards: string[]) {
    for (let card of whiteCards) {
        if (blackCard.includes("_")) blackCard = blackCard.replace("_", "**" + card + "**")
        else blackCard += " **" + card + "**"
    }
    console.log("Populated black card:", blackCard, "Using white cards:", whiteCards)
    return blackCard
}